import { makeStyles } from "@material-ui/core/styles";
const useStyles = makeStyles((theme) => ({
  button: {
    backgroundColor: "#grey",
    margin: 3,
    width: "30%",
  },
  timer: {
    fontSize: "1.2em",
  },
  time: {
    fontSize: "3em",
  },
}));

  export default useStyles;